import React from 'react'
import classNames from 'classnames'
import { Field, connect } from 'formik'
import { FormRadio } from 'shared'
import { FormValues } from 'donate/types'

export const RecurringSelection = connect<{ labelClass?: string }, FormValues>(
  ({ formik, labelClass: _labelClass }) => {
    if (!formik.values._show_recurring) return null

    const isRecurringPaymentMethod = ['stripe_sepa_debit', 'paypal', 'stripe_cc'].includes(formik.values.payment_method)

    // Only add py-3 if no other py-* given
    const labelClass = classNames(_labelClass, !_labelClass?.includes('py') && 'py-3')

    return (
      <div className="form-group flex mb-0 space-x-3">
        <Field
          name="interval"
          component={FormRadio}
          className={classNames('cursor-pointer', labelClass)}
          value="single"
          label={i18n.t(`donate.recurring_interval.single`)}
        />

        <Field
          name="interval"
          component={FormRadio}
          className={classNames('cursor-pointer', labelClass)}
          value="monthly"
          label={i18n.t(`donate.recurring_interval.monthly`)}
          disabled={!isRecurringPaymentMethod}
          disabledInfo={i18n.t('donate.recurring_disabled_popover')}
        />

        <Field
          name="interval"
          component={FormRadio}
          className={classNames('cursor-pointer', labelClass)}
          value="yearly"
          label={i18n.t(`donate.recurring_interval.yearly`)}
          disabled={!isRecurringPaymentMethod}
          disabledInfo={i18n.t('donate.recurring_disabled_popover')}
        />
      </div>
    )
  }
)
